import { c as _c } from "react/compiler-runtime";
/**
 * @file user-details-modal.tsx
 * @description
 * -----------------------------------------------------
 * Modal para mostrar los detalles de un usuario
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2026-04-01
 * @author DLTCode
 * @author Sergio Manjón
 * @copyright © DLTCode
 * @license Private
 * */

import { ColumnsAllUsers } from "@/types/commons/columns";
import ModalComponent from "@/components/modals/ModalComponent";
import { useTranslations } from "next-intl";
import { UserRoles } from "../enum";
interface UserDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  user: ColumnsAllUsers;
}
const UserDetailsModal = t0 => {
  const $ = _c(40);
  const {
    isOpen,
    onClose,
    user
  } = t0;
  const modals = useTranslations("Modals");
  const labels = useTranslations("Labels");
  const toggle = useTranslations("ToggleComponent");
  const options = useTranslations("SelectComponent.Options");
  let t1;
  if ($[0] !== options || $[1] !== user) {
    t1 = Object.values(UserRoles).includes(user?.role as UserRoles) ? options(user.role as UserRoles) : "-";
    $[0] = options;
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const role = t1;
  let t2;
  if ($[3] !== labels) {
    t2 = labels("labelMail");
    $[3] = labels;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = user?.email || "-";
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = {
      id: "user-details-mail",
      label: t2,
      value: t3
    };
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== labels) {
    t5 = labels("labelName");
    $[8] = labels;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = user?.name || "-";
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = {
      id: "user-details-name",
      label: t5,
      value: t6
    };
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== labels) {
    t8 = labels("labelRole");
    $[13] = labels;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== role || $[16] !== t8) {
    t9 = {
      id: "user-details-role",
      label: t8,
      value: role
    };
    $[15] = role;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== labels) {
    t10 = labels("label2FA");
    $[18] = labels;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== toggle || $[21] !== user?.twoFactorCode) {
    t11 = user?.twoFactorCode ? toggle("active") : toggle("deactivate");
    $[20] = toggle;
    $[21] = user?.twoFactorCode;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11) {
    t12 = {
      id: "user-details-2fa",
      label: t10,
      value: t11
    };
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t4 || $[28] !== t7 || $[29] !== t9) {
    t13 = [t4, t7, t9, t12];
    $[26] = t12;
    $[27] = t4;
    $[28] = t7;
    $[29] = t9;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const detailFields = t13;
  let t14;
  if ($[31] !== modals) {
    t14 = modals("userDetails.title");
    $[31] = modals;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== detailFields) {
    t15 = <dl className="modal__details modal__details--static">{detailFields.map(_temp)}</dl>;
    $[33] = detailFields;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== isOpen || $[36] !== onClose || $[37] !== t14 || $[38] !== t15) {
    t16 = <ModalComponent title={t14} isOpen={isOpen} onClose={onClose} buttonCancel={false} buttonConfirmText="buttonAccept" onConfirm={onClose} buttonConfirmClassname="input--full">{t15}</ModalComponent>;
    $[35] = isOpen;
    $[36] = onClose;
    $[37] = t14;
    $[38] = t15;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  return t16;
};
export default UserDetailsModal;
function _temp(t0) {
  const {
    id,
    label,
    value
  } = t0;
  return <div key={id} className="modal__details__field"><dt id={`${id}-label`} className="label">{label}</dt><dd aria-labelledby={`${id}-label`} className="modal__details__value">{value}</dd></div>;
}